import React, { useState,useEffect,navigate,useMemo  } from 'react';
import Dialog from '@mui/material/Dialog';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import { useForm, Controller  } from "react-hook-form";
import Typography from '@mui/material/Typography';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import NativeSelect from '@mui/material/NativeSelect';
import FormHelperText from '@mui/material/FormHelperText';
import { getWorkordersById,  simulateMyWorkorder} from "../../../REST/workorders";
import { getAllMyInspections } from '../../../REST/inspections';
import { Checkbox, FormControlLabel } from "@material-ui/core";
import moment from 'moment';
 

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
 
export default function AddWorkorder(props) {
 const {handleClose,id} = props
 const [workorder,setWorkorder]= useState(null)
 const [inspections,setInspections] = useState(null)
 
 const [loaded,setLoaded] = useState(false)
 useEffect(() => {
  getWorkordersById(id)
  .then(({data})=>{    
    setWorkorder(data)
    return getAllMyInspections( )
   

  })
  .then((res)=>{
    setInspections(res.data)
    setLoaded(true)   
    }
  )
  .catch((e)=>{ debugger; navigate("/Workorder") })

}, []);
 const getSelect =  ()=>{
    
      return [<option key='temp'>Select One</option>].concat(inspections.map((e, idx) => {
			let name = e.name + "("+ moment(e.createdDate).format("MM/DD/yyyy HH:ss")+")"
			return <option key={idx} value={e._id}>{name}</option>
		}))
     
 }
 const schema = yup.object({
    refnumber:yup.string().trim().required(), 
    workorderfor : yup.string().trim(),     
    name: yup.string().trim().required(),
    email: yup.string().trim().required(),
   
}).required();


const { control, watch, handleSubmit, clearErrors, reset, formState: { errors } } = useForm({
    defaultValues: {
        refnumber: 'LWO-' + crypto.randomUUID().split('-')[0].slice(0,4).toUpperCase(),
        name: '',
        email: '',
        workorderfor: '' 
    },
    resolver: yupResolver(schema)
});
 

const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

const saveForm = (data) => {
  let record = {
    ...data,data:{},
     
    workorderId:id,status:"Created"
  } 
 
    simulateMyWorkorder(record)
    .then(handleClose)	
}
  
   if(!loaded) return (<></>)
  return (
    
      
      <Dialog
        fullScreen
        open={true}
        onClose={()=>{handleClose()}}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ justifyContent: 'space-between' }}>
            <IconButton   edge="start"  color="inherit"  onClick={handleClose}  aria-label="close"  >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Create Workorder
            </Typography>
            <IconButton   edge="start"  color="inherit"  onClick={handleSubmit(saveForm)}  aria-label="close"  >
              <SaveOutlined />
            </IconButton>
             
          
          </Toolbar>


        </AppBar>
        <Box p={2}>
        
            
        
          <Controller name="refnumber" control={control}
                        render={({ field }) =>
                            <TextField  margin='dense' error={isError(errors.refnumber)} helperText={errors.refnumber && errors.refnumber.message}
                                fullWidth label='Workorder Reference Number' {...field} InputProps={{ readOnly: true }} />} />
              
          
          {!workorder.adhoc &&
             
              <Controller name="workorderfor" control={control}
                render={({ field }) =>
                  <FormControl required error={isError(errors.workorderfor)} variant='standard' margin='dense' fullWidth>
                    <InputLabel shrink>Workorder For</InputLabel>
                    <NativeSelect {...field} >{getSelect()}</NativeSelect>
                    {errors.workorderfor && <FormHelperText>{errors.workorderfor.message}</FormHelperText>}
                            </FormControl>} />
            
          }
           <Controller name="name" control={control}
                        render={({ field }) =>
                            <TextField required margin='dense' error={isError(errors.name)} helperText={errors.name && errors.name.message}
                                fullWidth label='Tenant Name' {...field} />} />
            <Controller name="email" control={control}
                        render={({ field }) =>
                            <TextField required margin='dense' error={isError(errors.email)} helperText={errors.email && errors.email.message}
                                fullWidth label='Tenant Email' {...field} />} />
      </Box>  
      </Dialog>
     
  );
}